import { useEffect } from "react";
import { useAuthStore } from "@/stores/authStore";

export function useProfile() {
  const user = useAuthStore((state) => state.user);
  const profile = useAuthStore((state) => state.profile);
  const authStatus = useAuthStore((state) => state.authStatus);
  const profileStatus = useAuthStore((state) => state.profileStatus);
  const authError = useAuthStore((state) => state.authError);
  const refreshProfile = useAuthStore((state) => state.refreshProfile);
  const saveProfile = useAuthStore((state) => state.saveProfile);

  useEffect(() => {
    if (authStatus === "authenticated" && user && !profile && profileStatus === "idle") {
      void refreshProfile();
    }
  }, [authStatus, profile, profileStatus, refreshProfile, user]);

  return {
    profile,
    isLoading: profileStatus === "loading",
    error: authError,
    refreshProfile,
    saveProfile,
  };
}
